<template>
    <div class="menu">
        <ul class="menu-ul">
            <li class="menu-li" v-for="(item,index) in menuArr" :key="index" @click="toDetail(item.path)">
                <template v-if="!item.isELeIcon">
                    <div class="menu-left">
                        <van-icon :name="item.icon" size="18" />
                        <span class="menu-name">{{item.title}}</span>
                    </div>
                    <div class="pull-right" v-if="item.count">
                        <van-badge :content="item.count" />
                    </div>
                </template>
                <template v-else>
                    <div class="menu-left">
                        <i :class="`${item.icon} elIcon`"></i>
                        <span class="menu-name">{{item.title}}</span>
                    </div>
                    <div class="pull-right" v-if="item.count">
                        <van-badge :content="item.count" />
                    </div>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
import { Icon,Badge,Toast } from 'vant';
import { getPDAMenu } from '@/api/mobile/signIn_api';
import { mapState } from 'vuex'

export default {
    data() {
        return {
            menuArr: [],
            menuData:[]
        }
    },
    components: {
      [Icon.name]: Icon,
      [Badge.name]: Badge,
      [Toast.name]: Toast,
    },
    computed: {
        ...mapState({ warehouse: state => state.common.warehouse })
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            this.getList(this.$route.query.title)
        },
        getList(menuName){
            const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
            const {warehouseId} = _warehouse
            const data = {
                storeHouseID:warehouseId,
                menuName:menuName
            }

            getPDAMenu(data).then(res=>{
                if(res.status === 200){
                    console.log(res.response)
                    this.menuData = res.response
                    
                    try{
                        //const menuNameArr = Object.keys(menuDic)
                        let arr = []
                        this.menuData.forEach((item)=>{
                            const dataItem = {
                            name:item.menuName,
                            title:item.menuName,
                            icon:item.icon,
                            path:item.pathAddress,
                            count:item.actionCount,
                            isELeIcon:item.icon.startsWith('el')?true:false,
                            };
                            arr.push(dataItem)
                                                    })
                        this.menuArr = arr
                    }catch{}
                }else{
                    Toast.fail(res.msg);
                }
            })
        },
        toDetail(path){
            console.log(path);
            this.$router.push(path);
        }
    }
}
</script>

<style scoped>
    .menu{
        height: 100%;
        width: 100%;
    }
    .menu .menu-li{
        height: 70px;
        border-bottom: 1px dashed #ccc;
        line-height: 70px;
        padding: 0 30px;
        font-size: 18;
        background-color: #fbf9fe;
    }
    .menu .menu-li .menu-left,.menu .menu-li .menu-right{
        display: inline-block;
    }
    .menu .menu-li .menu-right{
        float: right;
    }
    .menu .menu-name{
        vertical-align: middle;
        margin-left: 10px;
    }
    ::v-deep .van-icon{
        font-size: 27px !important;
        vertical-align: middle;
    }
    .elIcon{
        font-size: 26px;
        vertical-align: middle;
    }
</style>